import React, { useState, useEffect } from 'react';
import Cookies from 'js-cookie';

/**
 * Custom Search Promotion.
 */
const SearchPromotion: React.FC<{
  title: string;
  description: string;
  linkText?: string;
  linkUrl?: string;
  id: string;
  expireTime: number;
  endPromotion?: string;
  image?: string;
  imageOrientation?: string;
  backgroundColor?: string;
  featuredLink?: boolean;
}> = ({
  title,
  description,
  linkText,
  linkUrl,
  id,
  expireTime,
  endPromotion,
  image,
  imageOrientation = 'right',
  backgroundColor = 'gray-lightest',
  featuredLink = true,
}) => {
  const [showPromotion, setShowPromotion] = useState<boolean>(false);
  const today = new Date();
  const imageUrl =
    image && image.indexOf('http') === -1
      ? `https://varian.widen.net/content/${image}/webp?w=480`
      : image;

  /**
   * Close Promotion.
   *
   * @param {React.MouseEvent<HTMLButtonElement, MouseEvent>} event
   *   Promotion click event.
   */
  const closePromotion = (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ): void => {
    event.preventDefault();
    setShowPromotion(false);
    Cookies.set(id, `{promotion: ${id}}`, { expires: expireTime });
  };

  /**
   * Cookie Check.
   */
  useEffect(() => {
    if (expireTime === -1 || !Cookies.get(id)) {
      setShowPromotion(true);
    }
  }, [id, expireTime]);

  if (endPromotion && today > new Date(endPromotion) && expireTime !== -1) {
    return;
  }

  /**
   * Render.
   */
  if (showPromotion) {
    return (
      <div
        id={id}
        className={`promotion center-vertically small-gaps background-${backgroundColor}`}>
        <button
          className={`close-promotion`}
          onClick={(event) => closePromotion(event)}>
          close
        </button>
        {image ? (
          <div
            className={
              imageOrientation === 'left'
                ? `grid-1-3-columns`
                : `grid-3-1-columns`
            }>
            {/* Left image */}
            {imageOrientation === 'left' && (
              <div className={`img-container hidden-xs`}>
                <img
                  className={`img-responsive rounded-corners`}
                  loading="lazy"
                  src={imageUrl}
                  alt={title}
                />
              </div>
            )}

            {/* Promotion Text*/}
            <div className={`text-container center-vertically margin-auto`}>
              <h3>{title}</h3>
              <p dangerouslySetInnerHTML={{ __html: description }} />
              {linkText && linkUrl && (
                <div className={`link-container`}>
                  <a
                    className={featuredLink ? `featured-link` : `btn-primary`}
                    href={linkUrl}>
                    {linkText}
                  </a>
                </div>
              )}
            </div>

            {/* Right image */}
            {imageOrientation === 'right' && (
              <div className={`img-container hidden-xs`}>
                <img
                  className={`img-responsive rounded-corners`}
                  loading="lazy"
                  src={imageUrl}
                  alt={title}
                />
              </div>
            )}
          </div>
        ) : (
          <>
            <h3>{title}</h3>
            <p dangerouslySetInnerHTML={{ __html: description }} />
            {linkText && linkUrl && (
              <div className={`link-container`}>
                <a
                  className={featuredLink ? `featured-link` : `btn-primary`}
                  href={linkUrl}>
                  {linkText}
                </a>
              </div>
            )}
          </>
        )}
      </div>
    );
  }
};
export default SearchPromotion;
